export const IMAGE_CONFIG = {
  maxSize: 5 * 1024 * 1024,
  acceptedTypes: "image/*",
  dimensions: { maxHeight: "80px", maxWidth: "80px" },
  largeDimensions: { maxHeight: "200px" },
};
